import { Box, type BoxProps, styled } from "@mui/material";

export type CenteredBoxProps = BoxProps;

export const CenteredBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
